import React from 'react'
import { AboutInnerBanner } from '../../Components/Common/InnerBanner/AboutInnerBanner'
import AboutInnBanContent from '../../Components/Common/InnerBanner/AboutInnBanContent'
import RightHandSide from '../../Components/Common/Services/RightHandSide';
import TopContent from '../../Components/Common/Services/TopContent';
import TopContentTxt from '../../Components/Common/Services/TopContentTxt';
import DbListData from '../../Components/Common/Services/DbListData';
import DbList from '../../Components/Common/Services/DbList';
import AllDetailsData from '../../Components/Common/Services/AllDetailsData';
import AllDetails from '../../Components/Common/Services/AllDetails';
import Transition from '../../Components/Transition';
import { Helmet } from 'react-helmet';

const FertilityCounselling = () => {
  const {image, heading, pageName} = AboutInnBanContent.FertilityCounselling;
  const {banner, head, pOne, pTwo, highligth} = TopContentTxt.FertilityCounselling;
  const {dlHeading, Dldata} = DbListData.FertilityCounselling;
  const {AllDData} = AllDetailsData.FertilityCounselling;

  return (
    <>
    <Helmet>
      <title>Best Fertility Counselling and Specialists in Mumbai</title>
      <meta name='description' content='Best fertility counseling and IVF support in Mumbai to help couples cope with infertility challenges and treatments.' />
      <meta name='keywords' content='fertility counseling, fertility issues, male infertility, ivf treatment cost mumbai, ivf cost mumbai, pcos infertility, pcos and infertility, female infertility, reasons for infertility, fertility issues female, infertility causes in female' />
      <link rel="canonical" href="https://www.acmefertility.com/FertilityCounselling" />
      <meta name="robots" content="Index, follow " />
    </Helmet>
    <AboutInnerBanner image={image} heading={heading} pageName={pageName} />

    <div className="blog-details-area pt-100 pb-70">
      <div className="container">
        <div className="row">
          <div className="col-lg-8">
            <TopContent banner={banner} head={head} pOne={pOne} pTwo={pTwo} highligth={highligth} />

            <DbList dlHeading={dlHeading} Dldata={Dldata} />

            <AllDetails AllDData={AllDData} />
          </div>
          <div className="col-lg-4">
            <RightHandSide />
        </div>
        </div>
      </div>
    </div>
    </>
  )
}

export default Transition(FertilityCounselling) 